import {
    LIST_GENERATE_DATA_ANALYSIS_REQUEST,
    LIST_GENERATE_DATA_ANALYSIS_SUCCESS,
    LIST_GENERATE_DATA_ANALYSIS_FAILURE,
    GENERATE_DATA_ANALYSIS_REQUEST,
    GENERATE_DATA_ANALYSIS_SUCCESS,
    GENERATE_DATA_ANALYSIS_FAILURE,
    LIST_PROCESS_ANALYSIS_REQUEST,
    LIST_PROCESS_ANALYSIS_SUCCESS,
    LIST_PROCESS_ANALYSIS_FAILURE,
    DETAIL_PROCESS_ANALYSIS_REQUEST,
    DETAIL_PROCESS_ANALYSIS_SUCCESS,
    DETAIL_PROCESS_ANALYSIS_FAILURE,
    DETAIL_LIST_PROCESS_ANALYSIS_REQUEST,
    DETAIL_LIST_PROCESS_ANALYSIS_SUCCESS,
    DETAIL_LIST_PROCESS_ANALYSIS_FAILURE,
    EXPORT_DETAIL_LIST_PROCESS_ANALYSIS_REQUEST,
    EXPORT_DETAIL_LIST_PROCESS_ANALYSIS_SUCCESS,
    EXPORT_DETAIL_LIST_PROCESS_ANALYSIS_FAILURE,
    LIST_MANAGE_DATA_ANALYSIS_REQUEST,
    LIST_MANAGE_DATA_ANALYSIS_SUCCESS,
    LIST_MANAGE_DATA_ANALYSIS_FAILURE,
    GENERATE_MANAGE_DATA_ANALYSIS_REQUEST,
    GENERATE_MANAGE_DATA_ANALYSIS_SUCCESS,
    GENERATE_MANAGE_DATA_ANALYSIS_FAILURE,
    DELETE_MANAGE_DATA_ANALYSIS_REQUEST,
    DELETE_MANAGE_DATA_ANALYSIS_SUCCESS,
    DELETE_MANAGE_DATA_ANALYSIS_FAILURE
} from '../../constants/analysis'

const initialState = {
    listGenerateDataAnalysis: [],
    listProcessAnalysis: [],
    detailProcessAnalysis: {},
    detailListProcessAnalysis: [],
    listManageDataAnalysis: [],
    loadingGenerate: false,
    loadingDetailProcessAnalysis: false,
    loadingExportDetailProcessAnalysis: false,
    loading: false,
    error: null,
    pageable: {
        page: 1,
        size: 10,
        total: 0
    },
    generateDataAnalysis: null
}

const analysisReducer = (state = initialState, action) => {
    switch (action.type) {
        case LIST_GENERATE_DATA_ANALYSIS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            }
        case LIST_GENERATE_DATA_ANALYSIS_SUCCESS:
            return {
                ...state,
                loading: false,
                listGenerateDataAnalysis: action.payload,
                pageable: action.pageable,
                error: null
            }
        case LIST_GENERATE_DATA_ANALYSIS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                listGenerateDataAnalysis: action.dummy
            }
        case GENERATE_DATA_ANALYSIS_REQUEST:
            return {
                ...state,
                loadingGenerate: true,
                error: null
            }
        case GENERATE_DATA_ANALYSIS_SUCCESS:
            return {
                ...state,
                loadingGenerate: false,
                generateDataAnalysis: action.payload,
                error: null
            }
        case GENERATE_DATA_ANALYSIS_FAILURE:
            return {
                ...state,
                loadingGenerate: false,
                error: action.payload.error
            }
        case LIST_PROCESS_ANALYSIS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            }
        case LIST_PROCESS_ANALYSIS_SUCCESS:
            return {
                ...state,
                loading: false,
                listProcessAnalysis: action.payload,
                pageable: action.pageable,
                error: null
            }
        case LIST_PROCESS_ANALYSIS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                listProcessAnalysis: action.dummy
            }
        case DETAIL_PROCESS_ANALYSIS_REQUEST:
            return {
                ...state,
                loadingDetailProcessAnalysis: true,
                error: null
            }
        case DETAIL_PROCESS_ANALYSIS_SUCCESS:
            return {
                ...state,
                loadingDetailProcessAnalysis: false,
                detailProcessAnalysis: action.payload,
                error: null
            }
        case DETAIL_PROCESS_ANALYSIS_FAILURE:
            return {
                ...state,
                loadingDetailProcessAnalysis: false,
                error: action.payload.error,
                detailProcessAnalysis: action.dummy
            }
        case DETAIL_LIST_PROCESS_ANALYSIS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            }
        case DETAIL_LIST_PROCESS_ANALYSIS_SUCCESS:
            return {
                ...state,
                loading: false,
                detailListProcessAnalysis: action.payload,
                pageable: action.pageable,
                error: null
            }
        case DETAIL_LIST_PROCESS_ANALYSIS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                detailListProcessAnalysis: action.dummy
            }
        case EXPORT_DETAIL_LIST_PROCESS_ANALYSIS_REQUEST:
            return {
                ...state,
                loadingExportDetailProcessAnalysis: true,
                error: null
            }
        case EXPORT_DETAIL_LIST_PROCESS_ANALYSIS_SUCCESS:
            return {
                ...state,
                loadingExportDetailProcessAnalysis: false,
                error: null
            }
        case EXPORT_DETAIL_LIST_PROCESS_ANALYSIS_FAILURE:
            return {
                ...state,
                loadingExportDetailProcessAnalysis: false,
                error: action.payload.error
            }
        case LIST_MANAGE_DATA_ANALYSIS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            }
        case LIST_MANAGE_DATA_ANALYSIS_SUCCESS:
            return {
                ...state,
                loading: false,
                listManageDataAnalysis: action.payload,
                pageable: action.pageable,
                error: null
            }
        case LIST_MANAGE_DATA_ANALYSIS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                listManageDataAnalysis: action.dummy
            }
        case GENERATE_MANAGE_DATA_ANALYSIS_REQUEST:
            return {
                ...state,
                loadingGenerate: true,
                error: null
            }
        case GENERATE_MANAGE_DATA_ANALYSIS_SUCCESS:
            return {
                ...state,
                loadingGenerate: false,
                error: null
            }
        case GENERATE_MANAGE_DATA_ANALYSIS_FAILURE:
            return {
                ...state,
                loadingGenerate: false,
                error: action.payload.error
            }
        case DELETE_MANAGE_DATA_ANALYSIS_REQUEST:
            return {
                ...state,
                loadingDelete: true,
                error: null
            }
        case DELETE_MANAGE_DATA_ANALYSIS_SUCCESS:
            return {
                ...state,
                loadingDelete: false,
                error: null
            }
        case DELETE_MANAGE_DATA_ANALYSIS_FAILURE:
            return {
                ...state,
                loadingDelete: false,
                error: action.payload.error
            }
        default:
            return state
    }
}

export default analysisReducer